import { render, staticRenderFns } from "./MaterialStarRating.vue?vue&type=template&id=189ff0f6&scoped=true&"
import script from "./MaterialStarRating.vue?vue&type=script&lang=js&"
export * from "./MaterialStarRating.vue?vue&type=script&lang=js&"
import style0 from "./MaterialStarRating.vue?vue&type=style&index=0&id=189ff0f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189ff0f6",
  null
  
)

export default component.exports